import SecurityReportPage from 'pages/security-report/page'

export const securityReportRoutes = [
  { path: '/security-report', element: <SecurityReportPage /> },
]
